export const SMART_HANDLER_PATH = `handler`;
